import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import { faHome } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'


const Output = () => {
  return (<>
    <PageHeader
    title="QUARTA FASE: OUTPUT"
    description="DOPPIA MATRICE DI MATERIALITÀ E VALORE AGGIUNTO RIATTRIBUITO VAR"
    className="mb-3"
    >
    </PageHeader>
    
    <Card key="CRITERI"  style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
            <h5 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>Criteri</h5>
          </Card.Title>
          <Card.Text>
          <ul style={{listStyleType:"none"}}>
            <li key="ALL13">
          <Link to="scheda-13">
            SCHEDA 13 - CRITERI ELABORAZIONE DOPPIA MATRICE DI MATERIALITÀ  
            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
          </Link> 
          </li>

          <li key="ALL14">
          <Link to="scheda-14">
            SCHEDA 14 – CRITERI ELABORAZIONE VALORE AGGIUNTO RIATTRIBUITO VAR
            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
          </Link> 
          </li>

          </ul>
          </Card.Text>
        </Card.Body>
      </Card>

      <Card key="SCHEMI"  style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
          <h5 className="text-primary mb-0" style={{marginBottom:"3%"}}><span className="text-info fw-medium">Schemi</span></h5>
          </Card.Title>
          <Card.Text>
          <ul style={{listStyleType:"none"}}>
            <li key="ALL15">
              <Link to="scheda-15">
                SCHEDA 15 – SCHEMA DELLA DOPPIA MATRICE DI MATERIALITÀ  
                <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
              </Link> 
            </li>
            <li key="ALL16">
              <Link to="scheda-16">
                SCHEDA 16 – SCHEMA ATTRIBUZIONE TOTALE AZIENDA VAR ALLA SOSTENIBILITÀ E NON  
                <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
              </Link> 
            </li>
          </ul>
          </Card.Text>
        </Card.Body>
      </Card>

    </>)
};

export default Output;

/*
            <li key="ALL17">
              <Link to="scheda-17">
                SCHEDA 17 – SCHEMA RIEPILOGO DATI INSERITI IN INPUT  
                <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
              </Link> 
            </li>
*/